'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import type * as React from 'react';

import type { WithNativeDataTestIdAttribute, WithOptionalDataTestId } from '../../types/qa';
import { cn } from '../../utils';

type LabelProps = React.ComponentProps<typeof LabelPrimitive.Root> & WithOptionalDataTestId;

function Label({ className, dataTestId, ...props }: LabelProps) {
    const { 'data-testid': nativeTestId, ...rest } = props as React.ComponentProps<typeof LabelPrimitive.Root> & WithNativeDataTestIdAttribute;
    const testId = dataTestId ?? nativeTestId;
    return (
        <LabelPrimitive.Root
            data-slot="label"
            data-testid={testId}
            className={cn(
                'mb-3 flex flex-row select-none items-center gap-2 font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
                className,
            )}
            {...rest}
        />
    );
}

export { Label };
